var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.formTopMessage)?_c('Alert',{staticClass:"top-message",attrs:{"show-icon":"","type":_vm.colorType}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.formTopMessage)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }